import { render } from "./FacsimileComponent.vue?vue&type=template&id=756245cc"
import script from "./FacsimileComponent.vue?vue&type=script&lang=js"
export * from "./FacsimileComponent.vue?vue&type=script&lang=js"

import "./FacsimileComponent.vue?vue&type=style&index=0&id=756245cc&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__